import { InputPropsBase } from '../interfaces/Inputs';
import { LabelPosition } from '../models';
import React from 'react';
import './styles.scss';
import { Alignment, JustifyContents } from '../../layout/models';
import TsrTooltip from '../../tooltip';
import TsrSvgIcon from '../../assets/icons';
import { TooltipType } from '../models/TooltipType';

interface LabelProps extends Partial<InputPropsBase<any, any>> {
    content?: string | JSX.Element;
}

export const Label = (props: React.PropsWithChildren<LabelProps>) => {
    return (
        <>
            {props.content && (props.labelPosition === LabelPosition.Left || !props.labelPosition) ? (
                <label
                    className={
                        (props.textOverflow ? 'textOverflow' : '') +
                        (props.disabled ? ' disabled' : '') +
                        (props.className ? ' ' + props.className : '')
                    }
                    htmlFor={props.id}
                    style={{
                        gap: props.gap || 5,
                        display: props.textOverflow ? undefined : 'flex',
                        flex: props.labelLength || 1,
                        justifyContent: props.justify || JustifyContents.flexStart,
                        alignItems: props.align || Alignment.center,
                    }}
                >
                    {props.content}
                    {props.errorMessage && !props.disabled && (
                        <TsrTooltip type={TooltipType.Error} icon={true} content={props.errorMessage}>
                            <TsrSvgIcon icon="information" color="error" pointer />
                        </TsrTooltip>
                    )}
                    {props.infoMessage && !props.disabled && (
                        <TsrTooltip type={TooltipType.Info} icon={true} content={props.infoMessage}>
                            <TsrSvgIcon icon="information" pointer />
                        </TsrTooltip>
                    )}
                </label>
            ) : (
                <></>
            )}
            {props.children}
            {props.content && props.labelPosition === LabelPosition.Right ? (
                <label
                    className={
                        (props.textOverflow ? 'textOverflow' : '') +
                        (props.disabled ? ' disabled' : '') +
                        (props.className ? ' ' + props.className : '')
                    }
                    htmlFor={props.id}
                    style={{
                        display: props.textOverflow ? undefined : 'flex',
                        flex: props.labelLength || 1,
                    }}
                >
                    {props.content}
                </label>
            ) : (
                <></>
            )}
        </>
    );
};
